import { BrowserRouter, Routes, Route } from "react-router-dom";
import React from "react";
import "./App.scss";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { ToastContainer } from "react-toastify";
import HospitalLogin from "./pages/HospitalLogin";
import HospitalDashboard from "./pages/HospitalDashboard";
import HospitalAppointmentList from "./pages/HospitalAppointmentList";
import HospitalPatientEntry from "./pages/HospitalPatientEntry";
import HospitalProfile from "./pages/HospitalProfile";
import HospitalChangePassword from "./pages/HospitalChangePassword";
import HospitalPastPatients from "./pages/HospitalPastPatients";
import HospitalPatientFeedback from "./pages/HospitalPatientFeedback";
import PatientFeedbackReport from "./pages/partient-feedback/PatientFeedbackReport";
import Error404 from "./pages/Error404";
import PartientFeedback from "./pages/partient-feedback/PartientFeedback";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HospitalLogin />} />
        <Route path="/dashboard" element={<HospitalDashboard />} />
        <Route path="/appointments" element={<HospitalAppointmentList />} />
        <Route path="/patient-entry" element={<HospitalPatientEntry />} />
        <Route path="/profile" element={<HospitalProfile />} />
        <Route path="/change-password" element={<HospitalChangePassword />} />
        <Route path="/past-patients" element={<HospitalPastPatients />} />
        <Route path="/patient-feedback" element={<HospitalPatientFeedback />} />
        <Route path="/patient-feedback-report/:patientId" element={<PatientFeedbackReport />} />
        <Route path="/partient-feedback/:slug" element={<PartientFeedback />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
      <ToastContainer position="bottom-center" />
    </BrowserRouter>
  );
}

export default App;






